import { useContext, useState } from 'react'
import { IoClose } from 'react-icons/io5'
import { toast } from 'react-toastify'
import { Auth } from '../../../../contexts/allContext'
import { apiV1 } from '../../../../utils/api'
import PopupV1 from '../../../Resources/PopupV1/PopupV1'
import classes from './Popup.module.css'

export default function Popup({ setForm, form, singleSellerInfo, istrue, setTrue }) {
    const { stateAuth } = useContext(Auth)
    const token = stateAuth?.token

    const [commission, setCommission] = useState(singleSellerInfo.Commission?.final_percentage ?? '')

    const toastSuccess = () => {
        toast.dismiss()
        toast.success('Commission updated!', {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
        })
    }

    const toastError = () => {
        toast.dismiss()
        toast.error('Input field is requried!', {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
        })
    }

    const handleCommissionUpdate = async (commissionValue) => {
        if (commissionValue === '' || commissionValue === null || commissionValue === undefined) {
            toastError()
            return
        }

        try {
            const response = await fetch(`${apiV1}/commisions/${singleSellerInfo.Commission?.id}`, {
                method: 'PATCH',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                    commission_percentage: singleSellerInfo.Commission?.commission_percentage,
                    discount_percentage: singleSellerInfo.Commission?.discount_percentage,
                    final_percentage: commissionValue,
                }),
            })

            if (response.ok) {
                console.log('Success: Commission updated')
                setTrue(!istrue)
                toastSuccess()
            } else {
                console.log('Error: Something went wrong!')
            }
        } catch (error) {
            console.error('Request failed:', error)
        }
    }

    return (
        <div className={classes.container}>
            <PopupV1 setForm={setForm} form={form} width="30%">
                <div className={classes.close}>
                    <div className={classes.closeIcon}>
                        <p onClick={() => setForm(!form)}>
                            <IoClose size={20} />
                        </p>
                    </div>
                    <div className={classes.header}>
                        <p>Update {singleSellerInfo.Seller?.page_name} Commission</p>
                    </div>
                </div>
                <div className={classes.body}>
                    <label htmlFor="commission" className={classes.label}>
                        Update Commission
                    </label>
                    <input
                        type="number"
                        id="commission"
                        className={classes.input}
                        placeholder="Enter commission amount"
                        value={commission}
                        onChange={(e) => setCommission(e.target.value)}
                    />
                </div>
                <div className={classes.buttonGroup}>
                    <button className={classes.updateButton} onClick={() => handleCommissionUpdate(commission)}>
                        Update
                    </button>
                    <button className={classes.cancelButton} onClick={() => setForm(false)}>
                        Cancel
                    </button>
                </div>
            </PopupV1>
        </div>
    )
}
